import { render } from "./EligibilityPatientInfo.vue?vue&type=template&id=636326c4&ts=true"
import script from "./EligibilityPatientInfo.vue?vue&type=script&lang=ts"
export * from "./EligibilityPatientInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__